import { useSelector } from 'react-redux';
import { add, differenceInMonths, fromUnixTime } from 'date-fns';
import {
  selectMFControlPanelDateOffset,
  selectMFControlPanelLastConsulted,
} from 'redux/reducers/meteorologyFieldsControlPanelReducer';
import { useGetMaxHorizonDateQuery } from 'services/api/Meteorology';
import useHandleRequestErrors from 'utils/hooks/useHandleRequestErrors';
import { ResponseError } from 'services/api/base';

function getMaxOffset(baseDate: Date, period: string, nDays: number) {
  const maxDate = add(baseDate, { days: nDays });

  switch (period[0]) {
    case 'd':
      return nDays;
    case 'p':
      return Math.floor(nDays / 5);
    case 's':
      return Math.floor(nDays / 7);
    case 'm':
      return differenceInMonths(maxDate, baseDate);
    default:
      return 0;
  }
}

export default function useMaxOffset() {
  // Usa o snapshot da última consulta, não os filtros editáveis ao vivo:
  // o range de dias só deve refletir uma consulta efetivamente realizada.
  const lastConsulted = useSelector(selectMFControlPanelLastConsulted);
  const forecastUnixDate = lastConsulted?.forecastUnixDate;
  const baseDate = forecastUnixDate ? fromUnixTime(forecastUnixDate) : new Date();
  const models = lastConsulted?.models;
  const region = lastConsulted?.region;
  const period: string = lastConsulted?.period || 's+0';
  const offset: number = useSelector(selectMFControlPanelDateOffset) || 0;

  const { data, error } = useGetMaxHorizonDateQuery({
    provisionalDate: forecastUnixDate as number,
    region: region || '',
    modelList: models || [],
    runtime: 0,
    member: '0',
    AtmLevel: 'single_level',
    variable: 'prec',
    period: period.replace(/\d+/, offset.toString(10)),
  }, { skip: !lastConsulted });
  const maxHorizon = data?.data?.num_dias || 0;
  const maxOffset = getMaxOffset(baseDate, period, maxHorizon);

  useHandleRequestErrors(error as ResponseError);

  return maxOffset;
}
